// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ========== 1. Tailwind 的核心指令 ========== */
@tailwind base;
@tailwind components;
@tailwind utilities;

/* ========== 2. 你原本的全局样式 ========== */

/* 确保所有元素都使用border-box */
* {
  box-sizing: border-box;
}

/* body 的默认样式 */
body {
  margin: 0;
  padding: 0; /* 确保没有内边距 */
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* 确保根元素没有额外间距 */
#root {
  margin: 0;
  padding: 0;
}

/* 确保主要容器元素没有默认间距 */
.App,
.admin-dashboard,
.main-content {
  margin: 0;
  padding: 0;
}

/* code 标签的默认字体 */
code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* ========== 3. 玻璃态样式 ========== */
.glass-modal .modal-content {
  background: rgba(255, 255, 255, 0.1) !important;
  backdrop-filter: blur(10px) saturate(180%) !important;
  border: 1px solid rgba(255, 255, 255, 0.4) !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2) !important;
  color: #0ff !important;
}

.glass-modal .modal-header,
.glass-modal .modal-body,
.glass-modal .modal-footer {
  border-color: rgba(255, 255, 255, 0.2) !important;
}

.glass-modal .modal-title {
  color: #0ff !important;
  text-shadow: 0 0 8px #0ff, 0 0 16px #0ff;
}

.glass-modal p {
  color: #0ff;
  text-shadow: 0 0 8px #0ff;
}

/* ========== 4. Neon 圆形按钮 样式 ========== */
.neon-btn {
  width: 64px;
  height: 64px;
  border-radius: 50% !important;
  color: #0ff !important;
  text-shadow: 0 0 8px #0ff, 0 0 16px #0ff;
  background: rgba(0, 0, 0, 0.5) !important;
  border: 2px solid #0ff !important;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  transition: all 0.3s ease;
}
.neon-btn:hover {
  box-shadow: 0 0 12px #0ff, 0 0 24px #0ff;
  transform: scale(1.1);
}
.neon-btn:active {
  transform: scale(0.95);
}

/* ========== 5. Dynamic Island 风格黑色控制台 ========== */
@keyframes dynamicIsland {
  0% { transform: translateX(-50%) scale(1); }
  25% { transform: translateX(-50%) scale(1.05); }
  50% { transform: translateX(-50%) scale(1); }
  75% { transform: translateX(-50%) scale(1.02); }
  100% { transform: translateX(-50%) scale(1); }
}
.dynamic-console {
  position: absolute;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.8);
  color: #fff;
  padding: 8px 16px;
  border-radius: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
  font-size: 0.9rem;
  font-weight: 600;
  animation: dynamicIsland 4s ease-in-out infinite;
  z-index: 0;
  display: flex;
  align-items: center;
}

/* ========== 6. 设备信息面板样式 ========== */
.infoOverlay {
  position: absolute;
  top: 10px;
  right: 10px;
  /* 提升层级以覆盖 header */
  z-index: 100;
  width: auto;
  min-width: 600px; /* 调整宽度以避免超出屏幕 */
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
  padding: 12px 24px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  font-size: 0.9rem;
  font-weight: 500;
}

/* ========== 7. 响应式调整 ========== */
@media (max-width: 768px) {
  .infoOverlay {
    top: calc(56px + 8px) !important;
    right: 8px !important;
    left: 8px !important;
    min-width: unset !important;
    width: calc(100% - 16px) !important;
    max-width: none !important;
  }
  .sanqi-controls {
    position: absolute !important;
    bottom: env(safe-area-inset-bottom, 20px) !important;
    left: 50% !important;
    transform: translateX(-50%) !important;
    display: flex !important;
    flex-direction: row !important;
    flex-wrap: wrap !important;
    justify-content: center !important;
    gap: 8px !important;
    padding: 0 8px !important;
    z-index: 200 !important;
  }
  .neon-btn {
    width: 48px !important;
    height: 48px !important;
    font-size: 1rem !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,4CAA4C;AAC5C,cAAc;AACd,oBAAoB;AACpB,mBAAmB;;AAEnB,sCAAsC;;AAEtC,wBAAwB;AACxB;EACE,sBAAsB;AACxB;;AAEA,eAAe;AACf;EACE,SAAS;EACT,UAAU,EAAE,YAAY;EACxB;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA,gBAAgB;AAChB;EACE,SAAS;EACT,UAAU;AACZ;;AAEA,mBAAmB;AACnB;;;EAGE,SAAS;EACT,UAAU;AACZ;;AAEA,iBAAiB;AACjB;EACE;aACW;AACb;;AAEA,mCAAmC;AACnC;EACE,+CAA+C;EAC/C,qDAAqD;EACrD,qDAAqD;EACrD,oDAAoD;EACpD,sBAAsB;AACxB;;AAEA;;;EAGE,iDAAiD;AACnD;;AAEA;EACE,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA,0CAA0C;AAC1C;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,sBAAsB;EACtB,wCAAwC;EACxC,yCAAyC;EACzC,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,wCAAwC;EACxC,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;;AAEA,oDAAoD;AACpD;EACE,KAAK,oCAAoC,EAAE;EAC3C,MAAM,uCAAuC,EAAE;EAC/C,MAAM,oCAAoC,EAAE;EAC5C,MAAM,uCAAuC,EAAE;EAC/C,OAAO,oCAAoC,EAAE;AAC/C;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,8BAA8B;EAC9B,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,iBAAiB;EACjB,gBAAgB;EAChB,gDAAgD;EAChD,UAAU;EACV,aAAa;EACb,mBAAmB;AACrB;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,gBAAgB,EAAE,gBAAgB;EAClC,8BAA8B;EAC9B,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,wCAAwC;EACxC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC;EACE;IACE,gCAAgC;IAChC,qBAAqB;IACrB,oBAAoB;IACpB,2BAA2B;IAC3B,mCAAmC;IACnC,0BAA0B;EAC5B;EACA;IACE,6BAA6B;IAC7B,oDAAoD;IACpD,oBAAoB;IACpB,sCAAsC;IACtC,wBAAwB;IACxB,8BAA8B;IAC9B,0BAA0B;IAC1B,kCAAkC;IAClC,mBAAmB;IACnB,yBAAyB;IACzB,uBAAuB;EACzB;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;EAC5B;AACF","sourcesContent":["/* ========== 1. Tailwind 的核心指令 ========== */\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n/* ========== 2. 你原本的全局样式 ========== */\n\n/* 确保所有元素都使用border-box */\n* {\n  box-sizing: border-box;\n}\n\n/* body 的默认样式 */\nbody {\n  margin: 0;\n  padding: 0; /* 确保没有内边距 */\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n/* 确保根元素没有额外间距 */\n#root {\n  margin: 0;\n  padding: 0;\n}\n\n/* 确保主要容器元素没有默认间距 */\n.App,\n.admin-dashboard,\n.main-content {\n  margin: 0;\n  padding: 0;\n}\n\n/* code 标签的默认字体 */\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* ========== 3. 玻璃态样式 ========== */\n.glass-modal .modal-content {\n  background: rgba(255, 255, 255, 0.1) !important;\n  backdrop-filter: blur(10px) saturate(180%) !important;\n  border: 1px solid rgba(255, 255, 255, 0.4) !important;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2) !important;\n  color: #0ff !important;\n}\n\n.glass-modal .modal-header,\n.glass-modal .modal-body,\n.glass-modal .modal-footer {\n  border-color: rgba(255, 255, 255, 0.2) !important;\n}\n\n.glass-modal .modal-title {\n  color: #0ff !important;\n  text-shadow: 0 0 8px #0ff, 0 0 16px #0ff;\n}\n\n.glass-modal p {\n  color: #0ff;\n  text-shadow: 0 0 8px #0ff;\n}\n\n/* ========== 4. Neon 圆形按钮 样式 ========== */\n.neon-btn {\n  width: 64px;\n  height: 64px;\n  border-radius: 50% !important;\n  color: #0ff !important;\n  text-shadow: 0 0 8px #0ff, 0 0 16px #0ff;\n  background: rgba(0, 0, 0, 0.5) !important;\n  border: 2px solid #0ff !important;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.2rem;\n  transition: all 0.3s ease;\n}\n.neon-btn:hover {\n  box-shadow: 0 0 12px #0ff, 0 0 24px #0ff;\n  transform: scale(1.1);\n}\n.neon-btn:active {\n  transform: scale(0.95);\n}\n\n/* ========== 5. Dynamic Island 风格黑色控制台 ========== */\n@keyframes dynamicIsland {\n  0% { transform: translateX(-50%) scale(1); }\n  25% { transform: translateX(-50%) scale(1.05); }\n  50% { transform: translateX(-50%) scale(1); }\n  75% { transform: translateX(-50%) scale(1.02); }\n  100% { transform: translateX(-50%) scale(1); }\n}\n.dynamic-console {\n  position: absolute;\n  top: 12px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: rgba(0, 0, 0, 0.8);\n  color: #fff;\n  padding: 8px 16px;\n  border-radius: 20px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);\n  font-size: 0.9rem;\n  font-weight: 600;\n  animation: dynamicIsland 4s ease-in-out infinite;\n  z-index: 0;\n  display: flex;\n  align-items: center;\n}\n\n/* ========== 6. 设备信息面板样式 ========== */\n.infoOverlay {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  /* 提升层级以覆盖 header */\n  z-index: 100;\n  width: auto;\n  min-width: 600px; /* 调整宽度以避免超出屏幕 */\n  background: rgba(0, 0, 0, 0.7);\n  color: #fff;\n  padding: 12px 24px;\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n/* ========== 7. 响应式调整 ========== */\n@media (max-width: 768px) {\n  .infoOverlay {\n    top: calc(56px + 8px) !important;\n    right: 8px !important;\n    left: 8px !important;\n    min-width: unset !important;\n    width: calc(100% - 16px) !important;\n    max-width: none !important;\n  }\n  .sanqi-controls {\n    position: absolute !important;\n    bottom: env(safe-area-inset-bottom, 20px) !important;\n    left: 50% !important;\n    transform: translateX(-50%) !important;\n    display: flex !important;\n    flex-direction: row !important;\n    flex-wrap: wrap !important;\n    justify-content: center !important;\n    gap: 8px !important;\n    padding: 0 8px !important;\n    z-index: 200 !important;\n  }\n  .neon-btn {\n    width: 48px !important;\n    height: 48px !important;\n    font-size: 1rem !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
